export const FFR_MENU_VIEW_TAB = 'ffr_menu_view_tab';

